module.exports = __webpack_public_path__ + "static/BasisGrotesquePro-Regular.54ef7647.ttf";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/BasisGrotesquePro-Regular.ttf
// module id = 707
// module chunks = 168707334958949